import { render, staticRenderFns } from "./preSale-distributionStation-delivery-edit.vue?vue&type=template&id=2b35bec3&scoped=true"
import script from "./preSale-distributionStation-delivery-edit.vue?vue&type=script&lang=js"
export * from "./preSale-distributionStation-delivery-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35bec3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b35bec3')) {
      api.createRecord('2b35bec3', component.options)
    } else {
      api.reload('2b35bec3', component.options)
    }
    module.hot.accept("./preSale-distributionStation-delivery-edit.vue?vue&type=template&id=2b35bec3&scoped=true", function () {
      api.rerender('2b35bec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/distributionStation-management/distributionStation-delivery/preSale-distributionStation-delivery-edit.vue"
export default component.exports